      (() => {
        const VALID_SYSTEMS = ['AU', 'US', 'UK', 'EU'];
        const STORAGE_KEY = 'amaroso-size-system';
        const SCRIPT_VERSION = '3.0.0';
        let memorySystem = null;

        /*
         * Shopify Markets supplies the currently selected storefront country.
         * This is used only to choose the initial customer-facing size system.
         * A customer's saved manual choice always takes priority.
         */
        const SHOPIFY_COUNTRY =
          window.AmarosoSizeCountry || 'AU';

        const MARKET_DEFAULT_SYSTEMS = {
          /*
           * Australia and nearby markets that commonly shop in AU sizing.
           */
          AU: 'AU',
          NZ: 'AU',

          /*
           * United States sizing.
           */
          US: 'US',
          CA: 'US',

          /*
           * United Kingdom sizing.
           */
          GB: 'UK',

          /*
           * European sizing.
           */
          AT: 'EU',
          BE: 'EU',
          BG: 'EU',
          HR: 'EU',
          CY: 'EU',
          CZ: 'EU',
          DE: 'EU',
          DK: 'EU',
          EE: 'EU',
          ES: 'EU',
          FI: 'EU',
          FR: 'EU',
          GR: 'EU',
          HU: 'EU',
          IE: 'EU',
          IT: 'EU',
          LT: 'EU',
          LU: 'EU',
          LV: 'EU',
          MT: 'EU',
          NL: 'EU',
          PL: 'EU',
          PT: 'EU',
          RO: 'EU',
          SE: 'EU',
          SI: 'EU',
          SK: 'EU'
        };

        const getMarketDefaultSystem = () => {
          return (
            MARKET_DEFAULT_SYSTEMS[SHOPIFY_COUNTRY] ||
            'AU'
          );
        };

        /*
         * Letter and split-size conversions.
         *
         * AU deliberately keeps the product's original letter sizing.
         * The overseas tabs show the equivalent numerical size or range.
         */
        /*
         * Explicit AU clothing-size conversions.
         * Odd-number jeans are intentional in-between apparel sizes:
         * AU 7 = US 3 = UK 7 = EU 35, etc.
         */
        const NUMERIC_SIZE_CONVERSIONS = {
          '4':  { AU: '4',  US: '0',  UK: '4',  EU: '32' },
          '5':  { AU: '5',  US: '1',  UK: '5',  EU: '33' },
          '6':  { AU: '6',  US: '2',  UK: '6',  EU: '34' },
          '7':  { AU: '7',  US: '3',  UK: '7',  EU: '35' },
          '8':  { AU: '8',  US: '4',  UK: '8',  EU: '36' },
          '9':  { AU: '9',  US: '5',  UK: '9',  EU: '37' },
          '10': { AU: '10', US: '6',  UK: '10', EU: '38' },
          '11': { AU: '11', US: '7',  UK: '11', EU: '39' },
          '12': { AU: '12', US: '8',  UK: '12', EU: '40' },
          '13': { AU: '13', US: '9',  UK: '13', EU: '41' },
          '14': { AU: '14', US: '10', UK: '14', EU: '42' },
          '15': { AU: '15', US: '11', UK: '15', EU: '43' },
          '16': { AU: '16', US: '12', UK: '16', EU: '44' },
          '17': { AU: '17', US: '13', UK: '17', EU: '45' },
          '18': { AU: '18', US: '14', UK: '18', EU: '46' },
          '19': { AU: '19', US: '15', UK: '19', EU: '47' },
          '20': { AU: '20', US: '16', UK: '20', EU: '48' },
          '21': { AU: '21', US: '17', UK: '21', EU: '49' },
          '22': { AU: '22', US: '18', UK: '22', EU: '50' },
          '23': { AU: '23', US: '19', UK: '23', EU: '51' },
          '24': { AU: '24', US: '20', UK: '24', EU: '52' },
          '25': { AU: '25', US: '21', UK: '25', EU: '53' },
          '26': { AU: '26', US: '22', UK: '26', EU: '54' },
          '27': { AU: '27', US: '23', UK: '27', EU: '55' },
          '28': { AU: '28', US: '24', UK: '28', EU: '56' },
          '29': { AU: '29', US: '25', UK: '29', EU: '57' },
          '30': { AU: '30', US: '26', UK: '30', EU: '58' }
        };

        const LETTER_SIZE_CONVERSIONS = {
          'XXS': {
            AU: 'XXS',
            US: '0',
            UK: '4',
            EU: '32'
          },

          'XS': {
            AU: 'XS',
            US: '2',
            UK: '6',
            EU: '34'
          },

          'S': {
            AU: 'S',
            US: '4',
            UK: '8',
            EU: '36'
          },

          'M': {
            AU: 'M',
            US: '6',
            UK: '10',
            EU: '38'
          },

          'L': {
            AU: 'L',
            US: '8',
            UK: '12',
            EU: '40'
          },

          'XL': {
            AU: 'XL',
            US: '10',
            UK: '14',
            EU: '42'
          },

          'XXL': {
            AU: 'XXL',
            US: '12',
            UK: '16',
            EU: '44'
          },

          'XXXL': {
            AU: 'XXXL',
            US: '14',
            UK: '18',
            EU: '46'
          },

          'XS/S': {
            AU: 'XS/S',
            US: '2/4',
            UK: '6/8',
            EU: '34/36'
          },

          'S/M': {
            AU: 'S/M',
            US: '4/6',
            UK: '8/10',
            EU: '36/38'
          },

          'M/L': {
            AU: 'M/L',
            US: '6/8',
            UK: '10/12',
            EU: '38/40'
          },

          'L/XL': {
            AU: 'L/XL',
            US: '8/10',
            UK: '12/14',
            EU: '40/42'
          },

          'XL/XXL': {
            AU: 'XL/XXL',
            US: '10/12',
            UK: '14/16',
            EU: '42/44'
          },

          'XXL/XXXL': {
            AU: 'XXL/XXXL',
            US: '12/14',
            UK: '16/18',
            EU: '44/46'
          }
        };

        const normaliseSize = (value) => {
          return String(value || '')
            .trim()
            .toUpperCase()
            .replace(/\s*\/\s*/g, '/');
        };

        /*
         * Customer display preference only.
         *
         * Shopify variants, SKUs, inventory, orders and warehouse data
         * remain unchanged in their original AU sizing.
         */
        const getSavedSystem = () => {
          if (memorySystem) return memorySystem;
          try {
            const savedSystem =
              window.localStorage.getItem(STORAGE_KEY);

            /*
             * A manual customer choice always wins, regardless of market.
             */
            if (VALID_SYSTEMS.includes(savedSystem)) {
              return savedSystem;
            }

            /*
             * First visit, or no saved choice:
             * use the active Shopify Markets country.
             */
            return getMarketDefaultSystem();
          } catch (error) {
            return getMarketDefaultSystem();
          }
        };

        const saveSystem = (system) => {
          if (!VALID_SYSTEMS.includes(system)) {
            return false;
          }

          memorySystem = system;
          try {
            window.localStorage.setItem(
              STORAGE_KEY,
              system
            );

            return (
              window.localStorage.getItem(STORAGE_KEY) ===
              system
            );
          } catch (error) {
            return false;
          }
        };

        const convertNumericSize = (size, system) => {
          const conversion = NUMERIC_SIZE_CONVERSIONS[String(size)];

          if (!conversion) {
            return String(size);
          }

          return conversion[system] || conversion.AU;
        };

        const convertSize = (originalSize, system) => {
          const original = String(originalSize || '').trim();
          const cleanSize = normaliseSize(original);

          /*
           * Pure numerical AU clothing sizes, including odd-number
           * in-between jeans sizes:
           *
           * AU 7  = US 3  = UK 7  = EU 35
           * AU 8  = US 4  = UK 8  = EU 36
           */
          if (/^\d+$/.test(cleanSize)) {
            return convertNumericSize(cleanSize, system);
          }

          /*
           * Numerical sizes with a helpful letter in brackets:
           *
           * 6 (XS)  -> US 2 (XS)
           * 8 (S)   -> US 4 (S)
           * 10 (M)  -> US 6 (M)
           *
           * Only the numerical portion is converted. The bracketed
           * letter is preserved exactly as entered in Shopify.
           */
          const numericWithLetter =
            original.match(/^(\d+)\s*(\([^)]*\))$/);

          if (numericWithLetter) {
            const convertedNumber = convertNumericSize(
              numericWithLetter[1],
              system
            );

            return `${convertedNumber} ${numericWithLetter[2]}`;
          }

          /*
           * Letter and combined sizes such as S, M, S/M and M/L.
           */
          if (LETTER_SIZE_CONVERSIONS[cleanSize]) {
            return (
              LETTER_SIZE_CONVERSIONS[cleanSize][system] ||
              cleanSize
            );
          }

          /*
           * Unknown or product-specific values remain untouched:
           * One Size, Petite, Tall, Curve, 26W, OSFA, etc.
           */
          return original;
        };

        const updateContainer = (container, system) => {
          if (!container || !VALID_SYSTEMS.includes(system)) {
            return;
          }

          container
            .querySelectorAll(
              '.js-amaroso-size-label[data-au-size]'
            )
            .forEach((label) => {
              const convertedSize = convertSize(
                label.dataset.auSize,
                system
              );

              if (label.textContent.trim() !== convertedSize) {
                label.textContent = convertedSize;
              }
            });

          container
            .querySelectorAll('.amaroso-size-system')
            .forEach((button) => {
              const isActive =
                button.dataset.sizeSystem === system;

              button.classList.toggle('is-active', isActive);

              button.setAttribute(
                'aria-pressed',
                isActive ? 'true' : 'false'
              );
            });

          container.dataset.activeSizeSystem = system;
        };

        const updateAllContainers = (system) => {
          document
            .querySelectorAll('[data-amaroso-size-selector]')
            .forEach((container) => {
              updateContainer(container, system);
            });
        };

        const initialiseContainer = (container) => {
          if (!container) {
            return;
          }

          container.dataset.amarosoSizeReady = 'true';

          updateContainer(
            container,
            getSavedSystem()
          );
        };

        const initialiseAllContainers = () => {
          document
            .querySelectorAll(
              '[data-amaroso-size-selector]'
            )
            .forEach(initialiseContainer);
        };

        const refreshSizeSelector = () => {
          initialiseAllContainers();
          updateAllContainers(getSavedSystem());
          updateExtraLabels(getSavedSystem());
          syncCartProperties();
        };

        const handleSizeSystemClick = (event) => {
          const button = event.target.closest(
            '.amaroso-size-system[data-size-system]'
          );

          if (!button) {
            return;
          }

          event.preventDefault();

          const selectedSystem =
            button.dataset.sizeSystem;

          if (
            !VALID_SYSTEMS.includes(
              selectedSystem
            )
          ) {
            return;
          }

          /*
           * Save first, then update the visible labels.
           * The save is verified inside saveSystem().
           */
          saveSystem(selectedSystem);
          updateAllContainers(selectedSystem);
          updateExtraLabels(selectedSystem);
          syncCartProperties();
        };

        /*
         * Keep private line-item properties in sync with the customer's
         * visible size choice. These properties are customer-facing
         * presentation metadata only; the Shopify variant remains AU.
         */
        const syncCartProperties = () => {
          const system = getSavedSystem();
          document.querySelectorAll('script[data-amaroso-size-variant-map]').forEach((map) => {
            const form = map.closest('form');
            if (form && !form.dataset.amarosoSizeVariants) form.dataset.amarosoSizeVariants = map.textContent;
          });
          document.querySelectorAll('form[data-amaroso-size-variants]').forEach((form) => {
            const idInput = form.querySelector('[name="id"]:checked') || form.querySelector('[name="id"]');
            let variants;
            try { variants = JSON.parse(form.dataset.amarosoSizeVariants); } catch (error) { return; }
            const variant = variants.find((entry) => String(entry.id) === String(idInput && idInput.value));
            const systemInput = form.querySelector('[name="properties[_amaroso_size_system]"]');
            const displayInput = form.querySelector('[name="properties[_amaroso_display_size]"]');
            if (systemInput) systemInput.value = variant ? system : '';
            if (displayInput) displayInput.value = variant ? convertSize(variant.au, system) : '';
          });
        };

        // These are display labels only. Input values, variant IDs and filter URLs remain AU.
        const updateExtraLabels = (system) => {
          document.querySelectorAll('[data-amaroso-au-label]').forEach((label) => {
            const original = label.dataset.amarosoAuLabel;
            const value = convertSize(original, system);
            const text = system === 'AU' ? value : system + ' ' + value;
            if (label.textContent !== text) label.textContent = text;
          });
          // Globo owns this markup. Keep filter values explicitly AU until the live app
          // integration can be tested; never silently relabel a filtering value.
          document.querySelectorAll('.gf-option-block[data-filter-type]').forEach((block) => {
            if (String(block.dataset.filterType).toLowerCase() !== 'size') return;
            const heading = block.querySelector('.gf-block-title .h3 > span');
            if (heading && heading.textContent.trim() === 'Size') heading.textContent = 'Size (AU)';
          });
        };

        const exposePublicApi = () => {
          window.AmarosoSizeSelector = {
            version: SCRIPT_VERSION,
            country: SHOPIFY_COUNTRY,

            getMarketDefaultSystem() {
              return getMarketDefaultSystem();
            },

            getSystem() {
              return getSavedSystem();
            },

            convertSize(originalSize, system = getSavedSystem()) {
              if (!VALID_SYSTEMS.includes(system)) {
                system = 'AU';
              }

              return convertSize(originalSize, system);
            },

            setSystem(system) {
              if (!VALID_SYSTEMS.includes(system)) {
                return false;
              }

              const saved = saveSystem(system);
              updateAllContainers(system);
              updateExtraLabels(system);
              syncCartProperties();

              return saved;
            },

            refresh() {
              refreshSizeSelector();
              syncCartProperties();
            }
          };
        };

        /*
         * Use a versioned binding flag so an abandoned or cached earlier
         * implementation cannot block this script from attaching its
         * event listeners.
         */
        if (
          window.amarosoSizeSelectorBoundVersion !==
          SCRIPT_VERSION
        ) {
          window.amarosoSizeSelectorBoundVersion =
            SCRIPT_VERSION;

          /*
           * Capture phase makes this independent of whether another app
           * stops bubbling on its own buttons.
           */
          document.addEventListener(
            'click',
            handleSizeSystemClick,
            true
          );

          document.addEventListener(
            'change',
            (event) => {
              if (
                event.target.matches(
                  '[data-amaroso-size-selector] input.swatches__form--input, form[data-amaroso-size-variants] [name="id"]'
                )
              ) {
                syncCartProperties();
                queueMicrotask(syncCartProperties);
              }
            },
            true
          );

          document.addEventListener(
            'click',
            (event) => {
              if (
                event.target.closest(
                  '#addToCart, .js-ajax-submit'
                )
              ) {
                syncCartProperties();
                queueMicrotask(syncCartProperties);
              }
            },
            true
          );

          /*
           * Platmart's official lifecycle event.
           * Their product-swatches.js dispatches this after its swatches
           * have loaded or moved into position.
           */
          document.addEventListener(
            'pl-swatches-loaded',
            refreshSizeSelector
          );

          document.addEventListener(
            'shopify:section:load',
            refreshSizeSelector
          );

          window.addEventListener(
            'pageshow',
            refreshSizeSelector
          );
        }

        const startSizeSelector = () => {
          exposePublicApi();
          refreshSizeSelector();
          document.addEventListener('formdata', (event) => {
            if (!event.target.matches('form[data-amaroso-size-variants]')) return;
            syncCartProperties();
            ['_amaroso_size_system', '_amaroso_display_size'].forEach((key) => {
              const name = 'properties[' + key + ']';
              const input = event.target.querySelector('[name="' + name + '"]');
              if (input && input.value) event.formData.set(name, input.value);
            });
          }, true);
          let queued = false;
          new MutationObserver((records) => {
            if (queued || !records.some((record) => record.addedNodes.length)) return;
            queued = true;
            requestAnimationFrame(() => { queued = false; refreshSizeSelector(); });
          }).observe(document.body, { childList: true, subtree: true });
          window.addEventListener('storage', (event) => {
            if (event.key === STORAGE_KEY || event.key === null) {
              memorySystem = null;
              refreshSizeSelector();
            }
          });
        };

        if (document.readyState === 'loading') {
          document.addEventListener(
            'DOMContentLoaded',
            startSizeSelector,
            { once: true }
          );
        } else {
          startSizeSelector();
        }
      })();
